<form class="newRelatedPoint" aria-label="Add new related point">
  <div class="newRelatedPoint__selectWrapper">
    <pp-select
      class="newRelatedPoint__select"
      [ppSelectedItem]="selectedRelation"
      [ppItems]="relationOptions"
      (ppSelectItem)="selectItem($event)"
      [ppNoSearchBar]="true"
      [ppDisabled]="true"
      require
    >
      <!-- TODO Enable once different relations are added -->
      <ng-container selected>
        {{ selectedRelation.label }}
      </ng-container>
    </pp-select>
  </div>

  <div
    #pointButton
    role="button"
    class="newRelatedPoint__point"
    [id]="buttonId"
    aria-label="Select point"
    (click)="displayPointsDropdown()"
  >
    @if (selectedPoint) {
      <span
        ppTooltip
        [ppTitle]="selectedPoint.label"
        [ppTrimTooltip]="true"
        [attr.data-tooltip-title]="selectedPoint.label"
        data-trim-tooltip="true"
        class="newRelatedPoint__point__label"
        data-testid="point-label"
        >{{ selectedPoint.label }}</span
      >
    } @else {
      <span class="newRelatedPoint__point__placeholder">{{
        'related_points_select_point_placeholder' | ppTranslate
      }}</span>
    }

    <div class="selectCaret">
      <pp-icon
        [ppSVG]="
          dropdown.visible && dropdown.buttonId === buttonId
            ? iconMap[EIconPath.ICON_MISC_UP_ARROW_18]
            : iconMap[EIconPath.ICON_MISC_DOWN_ARROW_18]
        "
        aria-label="Select point caret"
        ppColor="grey-400"
        ppClass="setSize18"
      />
    </div>
  </div>

  @if (selectedPoint) {
    <button
      class="newRelatedPoint__button"
      (click)="addRelation()"
      type="button"
      aria-label="Confirm relation"
      [disabled]="processing"
    >
      <pp-spinner
        [ppLight]="true"
        [ppButton]="true"
        [ppHidden]="!processing"
        aria-label="Processing"
      />

      @if (!processing) {
        <pp-icon [ppSVG]="iconMap[EIconPath.ICON_NOTIFICATION_CHECK_18]" ppClass="setSize18" />
      }
    </button>
  } @else {
    <button
      class="newRelatedPoint__cancelButton"
      (click)="cancelAdding()"
      type="button"
      aria-label="Cancel relation"
    >
      <pp-icon
        [ppSVG]="iconMap[EIconPath.ICON_BIN_18]"
        ppClass="setSize18"
        ppColor="grey-400"
        ppHoverColor="grey-700"
      />
    </button>
  }
</form>
